import { DEEP_STORIES } from "@/mocks/content";

export default function DeepDive() {
  return (
    <section id="deep" className="w-full bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-2 text-sm font-bold tracking-[0.25em] text-primary-600">INVESTIGATION · 深度跟踪</p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">独家调查</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              用数周时间跨城核实、以多方信源互相印证，把一条条支离破碎的传闻拼成可以讲述的完整事实。
            </p>
          </div>
          <a
            href="#subscribe"
            className="inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-500 hover:text-primary-700"
          >
            提供你的选题线索 <i className="ri-add-line ml-1.5"></i>
          </a>
        </div>

        <div className="flex flex-col gap-6">
          {DEEP_STORIES.map((story) => (
            <article
              key={story.no}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200 lg:flex-row"
            >
              <div className="relative h-52 w-full shrink-0 overflow-hidden lg:h-auto lg:w-[46%]">
                <img
                  src={story.image}
                  alt={story.title}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-4 left-4 flex h-12 w-12 items-center justify-center rounded-md bg-foreground-950/85 font-heading text-xl font-black text-accent-400">
                  {story.no}
                </span>
              </div>
              <div className="flex flex-1 flex-col justify-center gap-3 p-6 md:p-8">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-100 px-2.5 py-1 text-xs font-semibold text-primary-700">
                    <i className="ri-sparkling-2-fill"></i> {story.category}
                  </span>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap text-xs font-medium text-foreground-500">
                    <i className="ri-time-line"></i> {story.duration}
                  </span>
                  <span className="ml-auto hidden whitespace-nowrap text-xs font-medium text-foreground-400 sm:inline-flex items-center gap-1">
                    <i className="ri-book-open-line"></i> {story.readTime}
                  </span>
                </div>
                <h3 className="font-heading text-lg leading-snug font-black text-foreground-950 transition-colors group-hover:text-primary-700 md:text-2xl">
                  {story.title}
                </h3>
                <p className="text-sm leading-relaxed text-foreground-600 md:text-base">{story.excerpt}</p>
                <div className="mt-1 flex items-center justify-between">
                  <a
                    href="#source"
                    className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 hover:text-primary-700"
                  >
                    阅读完整调查 <i className="ri-arrow-right-line"></i>
                  </a>
                  <span className="hidden items-center gap-1.5 whitespace-nowrap text-xs font-medium text-secondary-600 sm:inline-flex">
                    <i className="ri-price-tag-3-line"></i> {story.tag}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}